import React, {useState, useEffect} from 'react';
import { BrowserRouter, Routes, Route, Link, Outlet } from 'react-router-dom';


function About(){
return(
    <main>
        <h1>Hello World. This is About.</h1>
        <Link to={"/"} className="project">
            <p>The Home Page Link</p>
        </Link>
        <Link to={"/job"} className="project">
            <p>The Job Page Link</p>
        </Link>
    </main>
);

}
export default About